export default __webpack_public_path__ + "static/media/personality_ISFj.17fccb80.png";